<div class="pe-auto">
    <div *ngIf="buttons && buttons.length > 0" class="pe-auto">
      <i
        *ngFor="let button of buttons"
        class="pe-auto"
        [title]="button.label"
        [class]="button.class"
        (click)="handleButtonClick(button)"
      ></i>
    </div>
</div>
  